<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-row class="row-stats">
        <b-col md="12">
          <b-row>
            <b-col sm="4">
              <b-card>
                <div class="callout callout-success">
                  <small class="text-muted">Nombre total des utilisateurs</small><br>
                  <strong class="h4">{{ formatNumber(compteActif) }}</strong>
                </div>
                <!-- <div class="progress-group">
                  <div class="progress-group-header"><i class="icon-user progress-group-icon"></i>
                    <span class="title">Comptes actifs</span>
                    <span class="ml-auto font-weight-bold">{{ formatNumber(compteActif) }}
                      <span class="text-muted small">({{ percentageCactive }}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars"><div class="progress-xs progress">
                    <div role="progressbar" aria-valuemin="0" aria-valuemax="100" v-bind:aria-valuenow="percentageCactive" class="progress-bar bg-success" :style="{ width: percentageCactive + '%' }"></div>
                    </div>
                  </div>
                </div> -->
              </b-card>
            </b-col>
            <!-- <b-col sm="4">
              <b-card>
                <div class="callout callout-info">
                  <small class="text-muted">Nombre de documents de la bibliothèque</small><br>
                  <strong class="h4">{{ formatNumber(filecount) }}</strong>
                </div>
              </b-card>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
  data() {
    return {
      gestionnaires: '',
      compteActif: '',
      percentageCactive: '',
      filecount: 0
    }
  },
  mounted() {
    this.infosAccueil()
    // this.getFiles()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    infosAccueil() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/administration/accueil")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.gestionnaires = response.data.gestionnaires
          this.compteActif = response.data.compteActif
          this.percentageCactive = Math.round(response.data.percentageCactive)
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    getFiles() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/administration/countFiles")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.filecount = response.data.filecount
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    }
  }
}
</script>
